/* eslint-disable @typescript-eslint/no-unsafe-function-type */
/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/method-signature-style */
/* eslint-disable @stylistic/member-delimiter-style */

import { Fn }		from "ts-base/fn";
import { Duration }	from "ts-base/time/duration";

// stuff that works with both the node and the dom lib
// attention: using this in other environments might lead to runtime errors

//-----------------------------------------------------------------------------
//## window

export const btoa:Fn<string, string>	= (globalThis as any).btoa;
export const atob:Fn<string, string>	= (globalThis as any).atob;

//-----------------------------------------------------------------------------
//## timers

export type TimerId			= number;
export type TimerHandler	= string | Function;

export type SetTimer	= (handler:TimerHandler, timeout?:Duration, ...args:any[]) => TimerId;
export type ClearTimer	= (id:TimerId|undefined) => void;

export const setTimeout:SetTimer		= (globalThis as any).setTimeout;
export const clearTimeout:ClearTimer	= (globalThis as any).clearTimeout;

export const setInterval:SetTimer		= (globalThis as any).setInterval;
export const clearInterval:ClearTimer	= (globalThis as any).clearInterval;

//-----------------------------------------------------------------------------
//## performance

export type Performance	= Readonly<{
	now:	()=>number,
}>;

export const performance:Performance	= (globalThis as any).performance;

//-----------------------------------------------------------------------------
//## console

export type Console = Readonly<{
	assert(condition?: boolean, ...data: any[]): void;
	clear(): void;
	count(label?: string): void;
	countReset(label?: string): void;
	debug(...data: any[]): void;
	dir(item?: any, options?: any): void;
	dirxml(...data: any[]): void;
	error(...data: any[]): void;
	group(...data: any[]): void;
	groupCollapsed(...data: any[]): void;
	groupEnd(): void;
	info(...data: any[]): void;
	log(...data: any[]): void;
	table(tabularData?: any, properties?: string[]): void;
	time(label?: string): void;
	timeEnd(label?: string): void;
	timeLog(label?: string, ...data: any[]): void;
	timeStamp(label?: string): void;
	trace(...data: any[]): void;
	warn(...data: any[]): void;
}>;

export const console:Console	= (globalThis as any).console;

//-----------------------------------------------------------------------------
//## crypto

export type Crypto = Readonly<{
	randomUUID:			()	=> `${string}-${string}-${string}-${string}-${string}`,
	getRandomValues:	(typedArray:Int8Array|Uint8Array|Uint8ClampedArray|Int16Array|Uint16Array|Int32Array|Uint32Array|BigInt64Array|BigUint64Array) => void,
}>;

// ATTENTION this only works for node >= 19
export const crypto:Crypto	= (globalThis as any).crypto;

//-----------------------------------------------------------------------------
//## TextEncoder

export type TextEncoder	= Readonly<{
	encoding:	"utf-8",
	encode:		(str:string)					=> Uint8Array,
	encodeInto:	(str:string, arr:Uint8Array)	=> void,
}>;

export namespace TextEncoders {
	// always encodes to utf-8
	export const create	= ():TextEncoder	=>
		new (globalThis as any).TextEncoder();
}

//-----------------------------------------------------------------------------
//## TextDecoder

export type TextDecoder	= Readonly<{
	encoding:	"utf-8",
	fatal:		boolean,
	ignoreBOM:	boolean,
	decode:		(arr:Uint8Array)	=> string,
}>;

export namespace TextDecoders {
	// always decodes from utf-8
	export const create	= ():TextDecoder	=>
		new (globalThis as any).TextDecoder();

	export const createConfigured	= (label:Label, options:Options):TextDecoder	=>
		new (globalThis as any).TextDecoder(label, options);

	export type Options	= Readonly<{
		fatal?:		boolean,
		ignoreBOM?:	boolean,
	}>;

	export type Label	= typeof Labels[number];

	// @see https://developer.mozilla.org/en-US/docs/Web/API/Encoding_API/Encodings
	export const Labels	= [
		// utf-8
		"unicode-1-1-utf-8", "utf-8", "utf8",

		// ibm866
		"866", "cp866", "csibm866", "ibm866",

		// iso-8859-2
		"csisolatin2", "iso-8859-2", "iso-ir-101", "iso8859-2", "iso88592", "iso_8859-2", "iso_8859-2:1987", "l2", "latin2",

		// iso-8859-3
		"csisolatin3", "iso-8859-3", "iso-ir-109", "iso8859-3", "iso88593", "iso_8859-3", "iso_8859-3:1988", "l3", "latin3",

		// iso-8859-4
		"csisolatin4", "iso-8859-4", "iso-ir-110", "iso8859-4", "iso88594", "iso_8859-4", "iso_8859-4:1988", "l4", "latin4",

		// iso-8859-5
		"csisolatincyrillic", "cyrillic", "iso-8859-5", "iso-ir-144", "iso88595", "iso_8859-5", "iso_8859-5:1988",

		// iso-8859-6
		"arabic", "asmo-708", "csiso88596e", "csiso88596i", "csisolatinarabic", "ecma-114", "iso-8859-6", "iso-8859-6-e", "iso-8859-6-i", "iso-ir-127", "iso8859-6", "iso88596", "iso_8859-6", "iso_8859-6:1987",

		// iso-8859-7
		"csisolatingreek", "ecma-118", "elot_928", "greek", "greek8", "iso-8859-7", "iso-ir-126", "iso8859-7", "iso88597", "iso_8859-7", "iso_8859-7:1987", "sun_eu_greek",

		// iso-8859-8
		"csiso88598e", "csisolatinhebrew", "hebrew", "iso-8859-8", "iso-8859-8-e", "iso-ir-138", "iso8859-8", "iso88598", "iso_8859-8", "iso_8859-8:1988", "visual",

		// iso-8859-8i
		"csiso88598i", "iso-8859-8-i", "logical",

		// iso-8859-10
		"csisolatin6", "iso-8859-10", "iso-ir-157", "iso8859-10", "iso885910", "l6", "latin6",

		// iso-8859-13
		"iso-8859-13", "iso8859-13", "iso885913",

		// iso-8859-14
		"iso-8859-14", "iso8859-14", "iso885914",

		// iso-8859-15
		"csisolatin9", "iso-8859-15", "iso8859-15", "iso885915", "l9", "latin9",

		// iso-8859-16
		"iso-8859-16",

		// koi8-r
		"cskoi8r", "koi", "koi8", "koi8-r", "koi8_r",

		// koi8-u
		"koi8-u",

		// macintosh
		"csmacintosh", "mac", "macintosh", "x-mac-roman",

		// windows-874
		"dos-874", "iso-8859-11", "iso8859-11", "iso885911", "tis-620", "windows-874",

		// windows-1250
		"cp1250", "windows-1250", "x-cp1250",

		// windows-1251
		"cp1251", "windows-1251", "x-cp1251",

		// windows-1252
		"ansi_x3.4-1968", "ascii", "cp1252", "cp819", "csisolatin1", "ibm819", "iso-8859-1", "iso-ir-100", "iso8859-1", "iso88591", "iso_8859-1", "iso_8859-1:1987", "l1", "latin1", "us-ascii", "windows-1252", "x-cp1252",

		// windows-1253
		"cp1253", "windows-1253", "x-cp1253",

		// windows-1254
		"cp1254", "csisolatin5", "iso-8859-9", "iso-ir-148", "iso8859-9", "iso88599", "iso_8859-9", "iso_8859-9:1989", "l5", "latin5", "windows-1254", "x-cp1254",

		// windows-1255
		"cp1255", "windows-1255", "x-cp1255",

		// windows-1256
		"cp1256", "windows-1256", "x-cp1256",

		// windows-1257
		"cp1257", "windows-1257", "x-cp1257",
		// windows-1258
		"cp1258", "windows-1258", "x-cp1258",

		// x-mac-cyrillic
		"x-mac-cyrillic", "x-mac-ukrainian",

		// gbk
		"chinese", "csgb2312", "csiso58gb231280", "gb2312", "gb_2312", "gb_2312-80", "gbk", "iso-ir-58", "x-gbk",

		// gb18030
		"gb18030",

		// hz-gb-2312
		"hz-gb-2312",

		// big5
		"big5", "big5-hkscs", "cn-big5", "csbig5", "x-x-big5",

		// euc-jp
		"cseucpkdfmtjapanese", "euc-jp", "x-euc-jp",

		// iso-2022-jp
		"csiso2022jp", "iso-2022-jp",

		// shift-jis
		"csshiftjis", "ms_kanji", "shift-jis", "shift_jis", "sjis", "windows-31j", "x-sjis",

		// euc-kr
		"cseuckr", "csksc56011987", "euc-kr", "iso-ir-149", "korean", "ks_c_5601-1987", "ks_c_5601-1989", "ksc5601", "ksc_5601", "windows-949",

		// iso-2022-kr
		"csiso2022kr", "iso-2022-kr",

		// utf-16be
		"utf-16be",

		// utf-16le
		"utf-16", "utf-16le",

		// x-user-defined
		"x-user-defined",

		// replacement
		"iso-2022-cn", "iso-2022-cn-ext",
	] as const;
}
